import { SET_LICENSEKEY } from '../actionConstants';

export const setLicenseKeyAction = (payload) => {
  return {
    type: SET_LICENSEKEY,
    payload,
  };
};
